import { Component } from '@angular/core';

import { Stepper, StepperVertical } from 'src/app/core/models/properties';
import { listStepperVertical, listStepperHorizontal, listTabs } from '../../core/constants/properties-const';
import { ActivatedRoute, Router } from '@angular/router';
import { StepperService } from '../../core/services/step-service/stepper.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent {

  public listStepsVertical: StepperVertical [] = listStepperVertical;
  public listStepper: Stepper[] = listStepperHorizontal;
  public tabs = listTabs;

  public index = -1;
  public indexList = 0;

  constructor(
    private stepperService: StepperService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  public routerBack() {
    this.router.navigate(['/produtos'], { relativeTo: this.route });
  }

  public getClick(event: number) {
    this.index = -1;
    this.indexList = event;
    switch (event) {
      case 0:
        this.router.navigate(['produtos/registro']);
        break;
      case 1:
        this.router.navigate(['caracteristicas'], { relativeTo: this.route });
        break;
      case 2:
        this.router.navigate(['descricao'], { relativeTo: this.route });
        break;
      case 3:
        this.router.navigate(['midias'], { relativeTo: this.route });
        break;
      case 4:
        this.router.navigate(['profissional'], { relativeTo: this.route });
        break;
      case 5:
        this.router.navigate(['outras-informacoes'], { relativeTo: this.route });
        break;
    }
  }

  public progressStepper() {
    this.index += 1;
    if (this.index >= this.listStepsVertical[this.indexList].listStepper.length) {
      return false;
    }
    this.listStepsVertical[this.indexList].listStepper.forEach((resp, i) => resp.active ? this.index = (i + 1) : null);
    this.listStepsVertical[this.indexList].listStepper[this.index].active = true;
    this.stepperService.setList(this.listStepsVertical);
  }

  public updateStepper(index: number) {
    return index;
    // switch (index) {
    //   case 0:
    //     this.locacao.nativeElement.scrollIntoView();
    //     break;
    //   case 1:
    //     this.unidade.nativeElement.scrollIntoView();
    //     break;
    //   case 2:
    //     this.venda.nativeElement.scrollIntoView();
    //     break;
    // }
    // this.listStepsVertical.forEach((_, i: number) => this.listStepsVertical[i].listStepper[index].active = true);
  }


}

